import { NgClass, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterConfigOption, FilterSelected } from '@scalefast/core';

@Component({
  selector: 'app-multi-select',
  styleUrls: ['./multi-select.component.scss'],
  templateUrl: './multi-select.component.html',
  standalone: true,
  imports: [NgClass, ReactiveFormsModule, FormsModule, TitleCasePipe],
})
export class AppMultiSelectComponent implements OnInit {
  @Input() list: FilterConfigOption[] | undefined;
  @Input() name = '';
  @Output() shareCheckedList = new EventEmitter<Array<FilterSelected>>();

  checkedList: Array<FilterSelected> = [];
  label = '';
  showDropDown = false;
  filterValues: any;

  ngOnInit(): void {
    this.loadActiveValues();
    this.filterValues = this.list?.map((option) => option.value);
  }

  loadActiveValues() {
    if (this.list) {
      this.list.map((item: FilterConfigOption) => {
        if (item.checked) {
          this.checkedList.push({ label: item.label, value: item.value });
        }
      });
    }
  }

  getSelectedValue(option: FilterConfigOption) {
    if (option.checked) {
      this.checkedList.push({ label: option.label, value: option.value });
    } else {
      const index = this.checkedList.map((item: FilterSelected) => item.value).indexOf(option.value);
      if (index !== -1) {
        this.checkedList.splice(index, 1);
      }
    }

    //share checked list
    this.shareCheckedlist();
  }

  shareCheckedlist() {
    const clone = JSON.parse(JSON.stringify(this.checkedList));
    this.shareCheckedList.emit(clone);
  }

  isSeparator(value: string): boolean {
    return value.includes('separator');
  }
}
